import request from '@/utils/request'

export function getmorgnznp(orgcd, parmas) {
  return request({
    url: `/api/morgnznp/${orgcd}`,
    method: 'get',
    params: parmas,
  })
}
